let transforms = require("./plot/PlotTransforms");

let plot = {
  Plot: require("./plot/Plot"),
  XAxis: require("./plot/PlotXAxis"),
  YAxis: require("./plot/PlotYAxis"),
  Line: require("./plot/PlotLine"),
  RasterLine: require("./plot/PlotRasterLine"),
  Bars: require("./plot/PlotBars"),
  Boxes: require("./plot/PlotBoxes"),
  Area: require("./plot/PlotArea"),
  Scatter: require("./plot/PlotScatter"),
  RasterScatter: require("./plot/PlotRasterScatter"),
  CSVDownload: require("./plot/PlotCSVDownload")
};

module.exports = { ...plot, ...transforms };
